import MenuIcon from "@mui/icons-material/Menu";
import { Grid } from "@mui/material";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import { Icons } from "assets";
import classNames from "classnames";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getRoutes } from "shared/components/sidebar/constant";
import useBreadcrumbs from "shared/customHooks/useBreadCrumbs";
import useWindowSize from "shared/customHooks/windowSize";
import { rolesRoutes } from "shared/routes/allRoutes";
import { routeConstant } from "shared/routes/routesConstant";
import { roles_enums } from "./constants";
import styles from "./style.module.scss";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";

function PhNewDashboardView() {
  const navigate = useNavigate();
  const params = useParams();
  const routes = getRoutes();
  const screenWidth = useWindowSize();
  const [activePath, setActivePath] = useState<string>("");
  const [openSubMenu, setOpenSubMenu] = useState<string | null>(null);

  const handleClick = (item: any, hasSubMenu: boolean) => {
    setActivePath(item?.path);
    if (hasSubMenu) {
      setOpenSubMenu(openSubMenu === item?.path ? null : item?.path);
      setActivePath(item?.subMenu[0]?.path);
    }
  };

  const activeRoutes = useMemo(() => {
    return (
      routes.find(
        (role: any) =>
          role.role_id ===
          Number(
            roles_enums.find((itm: any) => itm?.keyword === params.role)?.id
          )
      )?.routes || []
    );
  }, [routes, params.role]);

  useEffect(() => {
    if (!roles_enums.some((itm: any) => itm?.keyword === params.role)) {
      navigate(-1);
    }
  }, [params.role, navigate]);

  useBreadcrumbs(
    {
      title: `${
        roles_enums.find((itm: any) => itm?.keyword === params.role)?.label
      } View`,
      path: routeConstant.dashboardView.path?.replace(
        ":role",
        String(params?.role)
      ),
    },
    true
  );

  useEffect(() => {
    if (activeRoutes.length > 0) {
      setActivePath(activeRoutes[0].path);
    }
    //eslint-disable-next-line
  }, []);

  const activeComponent = useMemo(() => {
    const roleId = Number(
      roles_enums.find((itm: any) => itm?.keyword === params.role)?.id
    );
    const roleRoute = rolesRoutes
      .find((item: any) => item?.role_id === roleId)
      ?.routes.find((itm: any) => itm?.path === activePath);
    return roleRoute ? <roleRoute.Component /> : null;
  }, [activePath, params.role]);

  useEffect(() => {
    let view = document.getElementById("table-view-dashboard");
    if (view) {
      view.style.width = "auto";
    }
  }, [activePath]);

  const renderSidebarItem = (item: any) => (
    <div
      key={item.path}
      onClick={() => {
        if (!item?.subMenu) {
          handleClick(item, !!item.subMenu);
        }
      }}
      className={classNames(
        activePath === item.path && styles.active,
        styles.sidebarItem
      )}
    >
      {item.title}
      {item.subMenu && <KeyboardArrowDownIcon />}
    </div>
  );

  const renderSubMenu = (subMenu: any[]) => (
    <div className={styles.subMenuContainer}>
      {subMenu.map((subItem, index, arr) => (
        <React.Fragment key={subItem.path}>
          <div
            onClick={() => handleClick(subItem, false)}
            className={classNames(
              activePath === subItem.path && styles.active,
              styles.sidebarItem,
              styles.sidebarSubItem
            )}
          >
            <KeyboardReturnIcon sx={{ transform: "scaleX(-1)" }} />{" "}
            <div className={styles.subTitleItem}>{subItem.title}</div>
          </div>
          {index !== arr.length - 1 && <div className={styles.separator} />}
        </React.Fragment>
      ))}
    </div>
  );

  return (
    <div>
      {screenWidth < 1300 && (
        <DashboardViewMenu
          activeRoutes={activeRoutes}
          activePath={activePath}
          setActivePath={setActivePath}
        />
      )}
      <Grid container spacing={2}>
        {screenWidth > 1300 && (
          <Grid
            item
            lg={2.5}
            xs={12}
            sx={{ display: "flex", flexDirection: "column", gap: "12px" }}
          >
            <div
              className={styles.backLabel}
              onClick={() => navigate(routeConstant.controlCenter.path)}
            >
              <Icons.PrevIcon /> Go back to control center
            </div>
            <div className={styles.sidebarContainer}>
              {activeRoutes.map((item: any) => (
                <React.Fragment key={item.path}>
                  {renderSidebarItem(item)}
                  {item.subMenu && renderSubMenu(item.subMenu)}

                  <div className={styles.separator} />
                </React.Fragment>
              ))}
            </div>
          </Grid>
        )}
        <Grid item xs={screenWidth > 1300 ? 9.5 : 12}>
          <div className={styles.componentContainer}>{activeComponent}</div>
        </Grid>
      </Grid>
    </div>
  );
}

export default PhNewDashboardView;

function DashboardViewMenu({ activeRoutes, activePath, setActivePath }: any) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        className={styles.menuBtn}
      >
        <MenuIcon sx={{ color: "black" }} />
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        PaperProps={{
          sx: {
            padding: "16px",
            justifyContent: "center",
            borderRadius: "10px",
          },
        }}
      >
        {activeRoutes.map((item: any, idx: number) => {
          if (item.subMenu) {
            return (
              <React.Fragment key={`${item.title}-${idx}`}>
                <div
                  className={classNames(styles.sidebarItem, styles.parentLabel)}
                >
                  {item.title}
                </div>
                {item.subMenu.map((sub: any) => (
                  <React.Fragment key={sub.path}>
                    <div
                      onClick={() => {
                        setActivePath(sub.path);
                        handleClose();
                      }}
                      className={classNames(
                        activePath === sub.path && styles.active,
                        styles.sidebarItem,
                        styles.sidebarSubItem
                      )}
                    >
                      <KeyboardReturnIcon sx={{ transform: "scaleX(-1)" }} />
                      <div className={styles.subTitleItem}>{sub.title}</div>
                    </div>
                    <div className={styles.separator} />
                  </React.Fragment>
                ))}
              </React.Fragment>
            );
          }

          if (!item.path) return null;

          return (
            <React.Fragment key={item.path}>
              <div
                onClick={() => {
                  setActivePath(item.path);
                  handleClose();
                }}
                className={classNames(
                  activePath === item.path && styles.active,
                  styles.sidebarItem
                )}
              >
                {item.title}
              </div>
              {idx !== activeRoutes.length - 1 && (
                <div className={styles.separator} />
              )}
            </React.Fragment>
          );
        })}
      </Menu>
    </div>
  );
}
